import { useEffect, useRef } from 'react';
import { IMessage, MessageTypes } from '../core/Interfaces';
import messageBus from '../core/MessageBus';

export default function useMessageListener<T extends IMessage>(
  type: MessageTypes,
  callback: (event: MessageEvent<T>) => void,
) {
  const callbackRef = useRef(callback);
  callbackRef.current = callback;

  useEffect(() => {
    const handler = (event: MessageEvent<IMessage>) => {
      callbackRef.current(event as MessageEvent<T>);
    };

    const unsubscribe = messageBus.subscribe(type, handler);
    return () => {
      unsubscribe();
    };
  }, [type]);
}
